// helpers/number.ts
var toNumber = (value) => value == null ? 0 : Number(value);

export { toNumber };
